import mpx from '@mpxjs/core'
// TODO: i18n 引用路径
import message from '../../../i18n/share'
import { request } from '../api/request'
import { GlobalConfig } from '../config'
import { GlobalEnv } from '../global_env'
import { URLQueries } from '../global_env/url_query'
import { build, is, canIUse, setShare, xenv, isHK } from '@didi/webx-js'
import { HKDomainConvert } from '../../js/hk_url'
import { cannotUseHarmonyosShare } from '../../js/util'

const Hosts = {
  online: 'https://page.udache.com/quartz-mall',
  pre: 'https://page.udache.com/quartz-mall',
  offline: window.location.origin,
}

const Host = HKDomainConvert(Hosts[process.env.BUILD_ENV], isHK)

const DCHN_MAP = {
  index: '9daDKJR',
  goodsDetail: '5GbYWKB',
  groupDetail: 'O7LBEp3',
  spikeDetail: 'r06zaeE',
  groupGoodsDetail: '0X1ME8R',
  orderDetail: 'WGZ5xM5', // 活动id 137153
  goodsProcess: 'O7LBEp3',
}

/**
 * @typedef DetailShareConfigRequest
 * @property {string|number} goodsId - 商品 ID
 */

/**
 * @typedef ShareConfig
 * @property {string} icon - 图标 URL
 * @property {string} title - 标题
 * @property {string} content - 内容
 */

/** @type {ShareConfig} */
const DefaultShareConfig = {
  icon: 'https://dpubstatic.udache.com/static/dpubimg/166755b0-6e4f-4ca1-a985-3637c3b2fec1.png',
  title: message[GlobalEnv.lang].title,
  content: message[GlobalEnv.lang].content,
}

/**
 * 获取详情页分享配置
 * @param {DetailShareConfigRequest} params - 请求参数
 * @return {ShareConfig}
 */
const getDetailPageShareConfigByGoodsID = async params => {
  try {
    const data = await request.get(
      GlobalConfig.APIs.shareConfig,
      {
        goods_id: params.goodsId,
      },
      {
        ignoreError: true,
      }
    )
    return data
      ? {
          icon: data.share_thumb_pic || DefaultShareConfig.icon,
          title: data.share_title || DefaultShareConfig.title,
          content: data.share_desc || DefaultShareConfig.content,
        }
      : { ...DefaultShareConfig }
  } catch (error) {
    return { ...DefaultShareConfig }
  }
}

/**
 * @typedef ShareOptions
 * @property {string} [pathname] - 页面路径
 * @property {boolean} [isDetail] - 是详情，需要请求接口拿配置
 * @property {DetailShareConfigRequest} [shareConfigRequestParams] - 详情接口请求参数
 * @property {string|number} [goodsId] - 商品id
 * @property {boolean} [addGoodsId = true] - 是否带商品 id
 * @property {ShareConfig} [shareConfig] - 自定义 title, content, icon
 */

// TODO: options 里这坨烂配置有空优化一下
/**
 * 设置详情页分享信息
 * @param {ShareOptions} options - 选项
 */
export const setPageShareConfig = async options => {
  // NOTICE: 纯血鸿蒙乘客端导航栏右上角分享按钮，低于 7.1.14 版本不支持分享微信小程序卡片和微信朋友圈
  if (cannotUseHarmonyosShare()) return
  try {
    let shareConfig = DefaultShareConfig
    if (options && options.isDetail && options.shareConfigRequestParams) {
      shareConfig = await getDetailPageShareConfigByGoodsID(
        options.shareConfigRequestParams
      )
    }
    if (options && options.shareData) {
      shareConfig = options.shareData
    }
    const { title, content, icon } = shareConfig
    const addGoodsId =
      options && options.addGoodsId !== undefined ? !!options.addGoodsId : true
    const pathname = options && options.pathname ? options.pathname : 'index'
    const queries = {
      ...(addGoodsId
        ? {
            id: options?.goodsId || URLQueries.getQuery('id'),
          }
        : {}),
      lang: GlobalEnv.lang,
      from: GlobalEnv.from,
      // dchn: pathname === 'orderDetail' ? '' : URLQueries.getQuery('dchn'),
    }
    const url = build(
      // TODO: 这个 URL 拼法实在坑。。。有空改一下
      `${Host}/${pathname}.html`,
      {
        ...queries,
        ...(options && options.extraQueries ? options.extraQueries : {}),
      }
    )
    const path =
      __mpx_mode__ === 'web' &&
      is('miniprogram') &&
      ((GlobalEnv.from !== 'xwebapp' && xenv() === 'wxmp') ||
        xenv() === 'yxwxmp')
        ? `/pages/bridgePage/index?type=webView&contentType=sell&xpsid_share=${
            mpx.xpsid
          }&url=${window.encodeURIComponent(
            build(url, {
              ...queries,
              ...(options && options.extraQueries ? options.extraQueries : {}),
            })
          )}`
        : build(xenv() === 'wxmp' ? '/webx/entry/wyc' : '/pages/index/index', {
            p: 'quartz-mall',
            scene: DCHN_MAP[pathname],
            ...queries,
            ...(options && options.extraQueries ? options.extraQueries : {}),
            needLogin: true,
            xpsid_share: mpx.xpsid,
          })
    const shareData = {
      img_url: icon, // 小程序分享图片
      card_content: title || '', // 小程序卡片标题
      ali_title: title, // 支付宝小程序标题
      ali_desc: content, // 支付宝小程序副标题
      title, // h5标题
      desc: content, // h5副标题
      icon, // h5图标
      poster_url: icon, // 微博海报
      channels: {
        wx_appmsg: [
          // 设置微信好友分享渠道
          {
            xenv: xenv(),
            ...(is('miniprogram') ||
            xenv() === 'passenger' ||
            xenv() === 'hypassenger'
              ? {
                  share_type: 'miniApp', // 分享类型：小程序
                  path: path, // 分享小程序路径(短链)
                  appid:
                    xenv() === 'hypassenger'
                      ? 'gh_b094e4f2edeb'
                      : 'gh_7a5c4141778f', // 分享出去的小程序AppId
                  miniprogram_type: 0, // 分享出的小程序版本类型 0:正式版 1:开发版 2:体验版
                }
              : {
                  share_type: 'text',
                  link: url,
                }),
          },
        ],
        wx_timeline: [
          // 如设置该channel 则分享面板中增加 分享到微信朋友圈Item
          {
            xenv: xenv(), // 当前环境xenv与该值相等时 取该配置作为分享配置
            share_type: 'text', // 分享类型
            link: url, // 分享链接
          },
        ],
      },
    }
    canIUse('setShare') && setShare(shareData)
    return shareData
  } catch (error) {
    return Promise.reject(error)
  }
}
